import { render } from "./MedicarePartA.vue?vue&type=template&id=60274a4c&scoped=true"
import script from "./MedicarePartA.vue?vue&type=script&lang=js"
export * from "./MedicarePartA.vue?vue&type=script&lang=js"

import "./MedicarePartA.vue?vue&type=style&index=0&id=60274a4c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60274a4c"]])

export default __exports__